export const BASE_SITE_URL = 'https://events.6ix.com';